import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';

import TextFieldPill from '../../../../01_atoms/FormElements/TextFieldPill';
import Button from '../../../../01_atoms/Button';
import { composeValidators } from '../../../../../utils/formFieldValidators';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBSimpleTextForm = ({
  title = '',
  placeholder = '',
  submitLabel = 'Submit',
  onSubmit = () => {},
  inputValidators = null,
  isRequired = false,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb bb-simple-text-form ${
      styles['bb-simple-text-form']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      {title && <h2 className="rockitt">{title}</h2>}

      <Form
        onSubmit={onSubmit}
        subscription={{ submitting: true, valid: true }}
        render={({ handleSubmit, submitting, valid }) => (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12 col-md-5 col-lg-6">
                <TextFieldPill
                  name="text"
                  placeholder={placeholder}
                  color="green"
                  validate={inputValidators ? composeValidators(...inputValidators) : undefined}
                  isRequired={isRequired}
                />
              </div>

              <div className="col-12 col-md-3 col-lg-2">
                <Button
                  type="secondary"
                  isBlock
                  isDisabled={!valid}
                  isLoading={submitting}
                  className="bb-simple-text-form--button"
                >
                  {submitLabel}
                </Button>
              </div>
            </div>
          </form>
        )}
      />
    </div>
  </div>
);

BBSimpleTextForm.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  inputValidators: PropTypes.arrayOf(PropTypes.func),
  isRequired: PropTypes.bool,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBSimpleTextForm;
